module.exports = __webpack_public_path__ + "static/media/lds-logo_en.a175ecb0.svg";